import { render, staticRenderFns } from "./FundsSelector.vue?vue&type=template&id=5dfd4cbe&"
import script from "./FundsSelector.vue?vue&type=script&lang=js&"
export * from "./FundsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports